// extracted by mini-css-extract-plugin
export default {"confirmDialog":"TrcWD8Pk","title":"Pvhsp3sY","description":"mq4SKW32","actions":"JGESK6DA"};